import { useNavigate, useRouteError } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Button from "../components/UI/Button";

export default function ErrorPage() {
  const { error } = useRouteError();
  const navigate = useNavigate();

  return (
    <main className="h-fit min-h-screen w-screen flex flex-col justify-between overflow-x-hidden bg-neutral">
      <Header />
      <div className="main-container flex-grow">
        <div className="content-container py-[2px] px-[10px] sm:px-[50px] md:px-[100px] mb-8">
          <div className="flex flex-col items-center justify-center w-full h-full">
            <h1 className="text-2xl md:text-3xl font-bold mb-2">Oops!</h1>
            <p className="break-all">
              Sorry, an unexpected error has occurred. &nbsp;
              <span>{error?.message}</span>
            </p>
            <p className="mb-10">Navigate back to the home page.</p>
            <Button isPrimaryButton={true} onClick={() => navigate("/")}>
              Click here!
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}
